import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";

const PaymentPending = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("orderId");

  const [status, setStatus] = useState("pending");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) return;

    checkStatus();
    const interval = setInterval(checkStatus, 5000);

    return () => clearInterval(interval);
  }, [orderId]);

  const checkStatus = async () => {
    try {
      const res = await api.get(`payment_status?orderId=${orderId}`);

      console.log("pendingpage", res.data);

      if (res.data.status === "success") {
        navigate(`/payment-success?orderId=${orderId}`);
      } else if (res.data.status === "failed") {
        navigate(`/payment-failure?orderId=${orderId}`);
      } else {
        setStatus("pending");
      }

      setLoading(false);
    } catch (err) {
      console.error("Status check failed", err);
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>⏳ Payment Processing</h2>
        <p>Your payment is being verified.</p>
        <p>Please do not refresh or close this page.</p>

        {loading ? <p>Checking status...</p> : <p>Status: {status}</p>}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    padding: 40,
    borderRadius: 10,
    background: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
};

export default PaymentPending;
